const jpgModules = import.meta.glob<{ default: string }>('./chotec-*.jpg', { eager: true });
const pngModules = import.meta.glob<{ default: string }>('./chotec-*.png', { eager: true });

const modules = { ...jpgModules, ...pngModules };

export const chotecImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/chotec-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/chotec-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp1 from './fp-1.jpg';
import fp2 from './fp-2.jpg';
import fp3 from './fp-3.jpg';
import fp4 from './fp-4.jpg';
import fp5 from './fp-5.jpg';

export const chotecFloorPlans = [
  { image: fp1, label: "1. NP – vizualizace A" },
  { image: fp2, label: "1. NP – vizualizace B" },
  { image: fp3, label: "1. NP – vizualizace C" },
  { image: fp4, label: "1. NP – vizualizace D" },
  { image: fp5, label: "1. NP – vizualizace E" },
];
